import React from "react";

type Props = {} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export default function Button({ className, children, ...props }: Props) {
  return (
    <button
      type={props.type ?? "button"}
      className={`generic-button ${className ?? ""}`}
      {...props}
    >
      {children}
    </button>
  );
}
